import { fail, oneOf } from "../infra/validation";
import type { SingleSite } from "../types";
import { LICENSES } from "@observe-tech/utils";

export const assertValidSite = (site: SingleSite): void => {
  if (typeof site.machine_id !== "number")
    fail("site.machine_id must be a number");
  if (typeof site.site_id !== "number") fail("site.site_id must be a number");
  if (typeof site.ip !== "string") fail("site.ip must be a string");
  if (typeof site.port !== "string") fail("site.port must be a string");
  if (site.license != null) oneOf(site.license, LICENSES, "site.license");
};
